import { createStore } from 'zustand';
import { SpaceDapp } from '@towns-protocol/web3';
// This function will create the store and initialize the spaceDapp if it doesn't already exist
const createSpaceDappStore = () => {
    return createStore((set) => ({
        spaceDapp: undefined,
        provider: undefined,
        config: undefined,
        setSpaceDapp: (spaceDapp, provider, config) => set({ spaceDapp, provider, config }),
    }));
};
const store = createSpaceDappStore();
export const useSpaceDappStore = (selector, provider, config) => {
    const { spaceDapp, setSpaceDapp, provider: currentProvider, config: currentConfig, } = store.getState();
    if (!spaceDapp || currentProvider !== provider || currentConfig !== config) {
        const newSpaceDapp = new SpaceDapp(config, provider);
        setSpaceDapp(newSpaceDapp, provider, config);
    }
    const cachedDapp = selector(store.getState());
    if (!cachedDapp) {
        throw new Error('useSpaceDappStore: spaceDapp is undefined');
    }
    return cachedDapp;
};
//# sourceMappingURL=use-space-dapp-store.js.map